"use client";
import { MinimalLiveAudioSkin as MinimalLiveAudioSkin$1 } from "../../internal/skins/minimal-live-audio/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/live-audio/minimal-skin.tsx
function MinimalLiveAudioSkin(props) {
	return /* @__PURE__ */ jsx(MinimalLiveAudioSkin$1, { ...props });
}
//#endregion
export { MinimalLiveAudioSkin };

//# sourceMappingURL=minimal-skin.js.map